// frontend/src/components/GestorEstadoTurnoAnses.js
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PlaceIcon from '@mui/icons-material/Place';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import DescriptionIcon from '@mui/icons-material/Description';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DownloadIcon from '@mui/icons-material/Download';
import cambioEstadoService from '../services/cambioEstadoService';
import EventoService from '../services/eventoService';
import NotificacionService from '../services/notificacionService';
import DatosMaestrosService from '../services/datosMaestrosService';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import ComboboxDatosMaestros from '../components/ComboboxDatosMaestros';
import BotonWhatsapp from '../components/BotonWhatsapp';
import ModificarEventoModal from '../components/ModificarEventoModal';
import TarjetaTurnoAnses from '../components/TarjetaTurnoAnses';
import { obtenerTurnoAnsesPorTramite } from '../services/turnoAnsesService';
import { agregarExpedienteAnses, getExpedientesAnses } from '../services/tramiteService';

// Función auxiliar para obtener la fecha actual en formato YYYY-MM-DD
const obtenerFechaActual = () => {
    const hoy = new Date();
    return hoy.toISOString().split('T')[0];
};

function GestorEstadoTurnoAnses({ tramite, onEstadoCambiado }) {
    const [cargando, setCargando] = useState(false);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [turnoAnsesInfo, setTurnoAnsesInfo] = useState(null);
    const [cargandoTurno, setCargandoTurno] = useState(false);
    const [mostrarFormularioJunta, setMostrarFormularioJunta] = useState(false);
    const [lugares, setLugares] = useState([]);
    const [datosJunta, setDatosJunta] = useState({ fecha: obtenerFechaActual(), hora: '', sede: '' , observaciones: '', numeroExpediente: '', sinJunta: false });
    const [mostrarModificar, setMostrarModificar] = useState(false);

    // Si el trámite ya tiene un turno ANSES de verdad (tabla turno_anses), este gestor no debe
    // manejarlo: acá el turno es solo un evento de agenda, sin citación en el turnero, sin
    // presentación y sin los campos nuevos. Los dos mecanismos comparten el mismo tipo de evento
    // ('Turno Anses'), así que sin esta guarda el gestor viejo se los come.
    const [turnoDelModuloNuevo, setTurnoDelModuloNuevo] = useState(null);
    const [verificandoModulo, setVerificandoModulo] = useState(true);

    const [datosAnses, setDatosAnses] = useState({
        fechaTurno: obtenerFechaActual(),
        horaTurno: '',
        lugar: '',
        observaciones: '',
        comprobante: null
    });

    useEffect(() => {
        cargarTurnoAnses();
        cargarLugares();
    }, [tramite.idTramite]);

    useEffect(() => {
        let cancelado = false;
        setVerificandoModulo(true);
        obtenerTurnoAnsesPorTramite(tramite.idTramite)
            .then((t) => { if (!cancelado) setTurnoDelModuloNuevo(t); })
            .catch(() => { if (!cancelado) setTurnoDelModuloNuevo(null); })
            .finally(() => { if (!cancelado) setVerificandoModulo(false); });
        return () => { cancelado = true; };
    }, [tramite.idTramite]);

    const cargarLugares = async () => {
        try {
            const response = await DatosMaestrosService.getLugares();
            setLugares(response.data);
        } catch (error) {
            console.error('Error al cargar lugares:', error);
        }
    };

    // Función para crear lugar automáticamente si no existe
    const crearLugarSiNoExiste = async (nombreLugar, tipoLugar = 'Oficina') => {
        if (!nombreLugar || nombreLugar.trim() === '') return;

        const nombreTrim = nombreLugar.trim();
        
        // Verificar si ya existe
        const lugarExistente = lugares.find(l => 
            l.nombre && l.nombre.toLowerCase() === nombreTrim.toLowerCase()
        );
        
        if (lugarExistente) {
            return lugarExistente; // Ya existe
        }

        try {
            const nuevoLugar = {
                nombre: nombreTrim,
                tipo: tipoLugar,
                direccion: '',
                telefono: '',
                descripcion: `Creado automáticamente desde trámite`
            };
            const response = await DatosMaestrosService.createLugar(nuevoLugar);
            console.log('✅ Lugar creado automáticamente:', response.data);
            
            // Recargar lugares para incluir el nuevo
            const lugaresActualizados = await DatosMaestrosService.getLugares();
            setLugares(lugaresActualizados.data);
            
            return response.data;
        } catch (error) {
            console.error('Error al crear lugar automáticamente:', error);
            return null;
        }
    };

    const cargarTurnoAnses = async () => {
        setCargandoTurno(true);
        try {
            const response = await EventoService.getEventosPorTramite(tramite.idTramite);
            const eventos = response.data;

            console.log('📋 Eventos cargados para trámite:', eventos);
            console.log('🔍 Buscando evento con tipoEvento === "Turno Anses"');

            // Filtrar eventos de tipo "Turno Anses"
            const eventosTurnoAnses = eventos.filter(e => {
                const tipoEvento = e.tipoEvento?.trim();
                // Comparar con el nombre exacto de la base de datos y también con variaciones
                return tipoEvento === 'Turno Anses' || 
                       tipoEvento?.toLowerCase() === 'turno anses';
            });

            console.log('✅ Eventos de tipo "Turno Anses" encontrados:', eventosTurnoAnses);

            // Obtener el más reciente (último creado) usando pop() o el más reciente por ID
            const eventoTurnoAnses = eventosTurnoAnses.length > 0 
                ? eventosTurnoAnses.sort((a, b) => (b.idEvento || 0) - (a.idEvento || 0))[0]
                : null;

            console.log('📌 Evento turno ANSES seleccionado:', eventoTurnoAnses);
            setTurnoAnsesInfo(eventoTurnoAnses || null);
        } catch (error) {
            console.error("❌ Error al cargar detalles del turno ANSES:", error);
            toast.error("No se pudieron cargar los detalles del turno ANSES.");
        } finally {
            setCargandoTurno(false);
        }
    };

    const handleCargarTurnoAnses = async () => {
        if (!validarFormulario()) return;

        setCargando(true);
        try {
            // Crear lugar automáticamente si no existe
            if (datosAnses.lugar && datosAnses.lugar.trim() !== '') {
                await crearLugarSiNoExiste(datosAnses.lugar, 'Oficina');
            }

            const eventoTurnoAnses = {
                titulo: `Turno Anses - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                descripcion: `Lugar: ${datosAnses.lugar || 'No especificado'}\nObservación: ${datosAnses.observaciones || 'No especificadas'}`,
                fecha: datosAnses.fechaTurno,
                horaInicio: datosAnses.horaTurno,
                horaFin: calcularHoraFin(datosAnses.horaTurno, 30),
                todoElDia: false,
                tipoEvento: 'Turno Anses',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };

            const response = await EventoService.crearEvento(eventoTurnoAnses);
            const eventoCreado = response.data;

            console.log('✅ Evento turno ANSES creado:', eventoCreado);

            // Actualizar el estado local con el evento creado inmediatamente
            if (eventoCreado && eventoCreado.tipoEvento === 'Turno Anses') {
                setTurnoAnsesInfo(eventoCreado);
                console.log('📌 Turno ANSES actualizado en estado local:', eventoCreado);
            }

            // Disparar evento personalizado para actualizar el calendario
            console.log('📅 GestorEstadoTurnoAnses: Evento creado - disparando actualización del calendario...');
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { 
                detail: { timestamp: Date.now(), source: 'tramite' } 
            }));

            const cambioEstadoData = {
                idEstado: 5, // Estado Turno ANSES
                comentario: `Turno Anses asignado\nFecha: ${formatearFecha(datosAnses.fechaTurno)}\nHora: ${datosAnses.horaTurno}\nLugar: ${datosAnses.lugar || 'No especificado'}\nObservación: ${datosAnses.observaciones || 'No especificadas'}`
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            // Recargar los detalles del turno ANSES para asegurar que tenemos la última versión
            // Esto es útil por si el evento se actualiza en el backend
            await cargarTurnoAnses();

            toast.success('Turno ANSES cargado correctamente');
            setMostrarFormulario(false);
            resetearFormulario();

            if (onEstadoCambiado) {
                onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al cargar turno ANSES:', error);
            toast.error('Error al cargar el turno ANSES: ' + (error.response?.data || error.message));
        } finally {
            setCargando(false);
        }
    };

    const handleReprogramarTurnoAnses = async () => {
        if (!validarFormulario()) return;

        setCargando(true);
        try {
            // Crear lugar automáticamente si no existe
            if (datosAnses.lugar && datosAnses.lugar.trim() !== '') {
                await crearLugarSiNoExiste(datosAnses.lugar, 'Oficina');
            }

            if (turnoAnsesInfo?.idEvento) {
                await EventoService.eliminarEvento(turnoAnsesInfo.idEvento);
            }

            const nuevoEventoData = {
                titulo: `Turno Anses (Reprogramado) - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                descripcion: `Lugar: ${datosAnses.lugar || 'No especificado'}\nObservación: ${datosAnses.observaciones || 'No especificadas'}`,
                fecha: datosAnses.fechaTurno,
                horaInicio: datosAnses.horaTurno,
                horaFin: calcularHoraFin(datosAnses.horaTurno, 30),
                todoElDia: false,
                tipoEvento: 'Turno Anses',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };

            await EventoService.crearEvento(nuevoEventoData);

            // Disparar evento personalizado para actualizar el calendario
            console.log('📅 GestorEstadoTurnoAnses: Evento reprogramado - disparando actualización del calendario...');
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { 
                detail: { timestamp: Date.now(), source: 'tramite' } 
            }));

            const cambioEstadoData = {
                idEstado: 5,
                comentario: `REPROGRAMACIÓN TURNO ANSES\nNueva fecha: ${formatearFecha(datosAnses.fechaTurno)}\nHora: ${datosAnses.horaTurno}\nLugar: ${datosAnses.lugar || 'No especificado'}\nObservación: ${datosAnses.observaciones || 'No especificadas'}`
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.success('Turno ANSES reprogramado correctamente');
            setMostrarFormulario(false);
            resetearFormulario();
            await cargarTurnoAnses(); // Recargar datos

            if (onEstadoCambiado) {
                onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al reprogramar turno ANSES:', error);
            toast.error('Error al reprogramar el turno ANSES');
        } finally {
            setCargando(false);
        }
    };

    const handleNoAsistioAnses = async () => {
        setCargando(true);
        try {
            const cambioEstadoData = {
                idEstado: 5,
                comentario: `⚠️ INASISTENCIA ANSES - El cliente no asistió al turno en ANSES.`
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.warning('Inasistencia a ANSES registrada');
            setMostrarFormulario(true);

            if (onEstadoCambiado) {
                onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al registrar inasistencia ANSES:', error);
            toast.error('Error al registrar la inasistencia a ANSES');
        } finally {
            setCargando(false);
        }
    };

    /**
     * Sin turno de junta médica (por ejemplo, por falta de declaración jurada), 15-oct-2026.
     * Se registra el expediente en el trámite (así lo reconocen el seguimiento, Para aprobar y los
     * avisos) y el trámite salta la junta: pasa directo a "Espera de 1° Dictamen" (estado 7),
     * a esperar la resolución de ANSES. No se crea evento de agenda.
     */
    const handleSinJuntaMedica = async () => {
        const nro = datosJunta.numeroExpediente.trim();
        if (!nro) {
            toast.error('Cargá el número de expediente para empezar el seguimiento.');
            return;
        }
        setCargando(true);
        try {
            // El expediente puede estar ya (cargado a mano o del resultado del turno ANSES).
            const soloDigitos = (t) => String(t || '').replace(/\D/g, '');
            const existentes = await getExpedientesAnses(tramite.idTramite);
            const yaEsta = (existentes || []).some((e) => soloDigitos(e.nroExpediente) === soloDigitos(nro));
            if (!yaEsta) {
                await agregarExpedienteAnses(tramite.idTramite, {
                    nroExpediente: nro, fechaIngreso: null, descripcion: 'Sin turno de junta médica',
                });
            }
            const comentario = `Sin turno de junta médica (falta de declaración jurada). Se sigue el expediente a la espera del dictamen.\nN° Expediente: ${nro}\nObservación: ${datosJunta.observaciones || 'No especificadas'}`;
            await handleRegistrarResultado(7, comentario); // Espera de 1° Dictamen

            setMostrarFormularioJunta(false);
            setDatosJunta({ fecha: obtenerFechaActual(), hora: '', sede: '', observaciones: '', numeroExpediente: '', sinJunta: false });
        } catch (error) {
            console.error('Error al registrar el trámite sin junta médica:', error);
            toast.error(error?.response?.data?.message || 'No se pudo registrar el trámite sin junta médica.');
        } finally {
            setCargando(false);
        }
    };

    const handleConfirmarJuntaMedica = async () => {
        if (datosJunta.sinJunta) {
            await handleSinJuntaMedica();
            return;
        }
        if (!datosJunta.fecha || !datosJunta.hora || !datosJunta.sede || !datosJunta.numeroExpediente.trim()) {
            toast.error("Debe completar fecha, hora, sede y número de expediente de la Junta Médica.");
            return;
        }
        setCargando(true);
        try {
            // Crear lugar automáticamente si no existe
            if (datosJunta.sede && datosJunta.sede.trim() !== '') {
                await crearLugarSiNoExiste(datosJunta.sede, 'Oficina');
            }

            const eventoJuntaMedica = {
                titulo: `Junta Médica - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                descripcion: `N° Expediente: ${datosJunta.numeroExpediente}\nSede: ${datosJunta.sede}\nObservación: ${datosJunta.observaciones || 'No especificadas'}`,
                fecha: datosJunta.fecha,
                horaInicio: datosJunta.hora,
                horaFin: calcularHoraFin(datosJunta.hora, 60),
                todoElDia: false,
                tipoEvento: 'Junta Médica',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };
            await EventoService.crearEvento(eventoJuntaMedica);

            // Disparar evento personalizado para actualizar el calendario
            console.log('📅 GestorEstadoTurnoAnses: Evento Junta Médica creado - disparando actualización del calendario...');
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { 
                detail: { timestamp: Date.now(), source: 'tramite' } 
            }));

            const comentario = `Junta Médica programada para el ${formatearFecha(datosJunta.fecha)} a las ${datosJunta.hora} en ${datosJunta.sede}.\nN° Expediente: ${datosJunta.numeroExpediente}\nObservación: ${datosJunta.observaciones || 'No especificadas'}`;
            await handleRegistrarResultado(6, comentario); // Cambia al estado 6

            setMostrarFormularioJunta(false);
            setDatosJunta({ fecha: obtenerFechaActual(), hora: '', sede: '', observaciones: '', numeroExpediente: '', sinJunta: false });

        } catch (error) {
            console.error('Error al registrar la Junta Médica:', error);
            toast.error('No se pudo registrar la Junta Médica.');
        } finally {
            setCargando(false);
        }
    };

    const handleRegistrarResultado = async (siguienteEstado, comentario) => {
        try {
            const cambioEstadoData = {
                idEstado: siguienteEstado,
                comentario: comentario
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.success('El estado del trámite se actualizó correctamente.');

            // Llama a la función onEstadoCambiado para refrescar la vista principal.
            if (onEstadoCambiado) {
                await onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al cambiar de estado:', error);
            // Lanza el error para que la función que llama pueda manejarlo en su bloque catch.
            throw error;
        }
    };
    const validarFormulario = () => {

        if (!datosAnses.fechaTurno || !datosAnses.horaTurno) {
            toast.error('La fecha y hora del turno son obligatorias');
            return false;
        }

        return true;
    };

    const calcularHoraFin = (horaInicio, minutos) => {
        if (!horaInicio) return '';
        const [horas, mins] = horaInicio.split(':').map(Number);
        const fecha = new Date();
        fecha.setHours(horas, mins + minutos, 0);
        return fecha.toTimeString().slice(0, 5);
    };

    const formatearFecha = (fechaString) => {
        if (!fechaString) return '';
        const fecha = new Date(fechaString);
        if (isNaN(fecha.getTime())) return '';
        const fechaLocal = new Date(fecha.valueOf() + fecha.getTimezoneOffset() * 60000);
        return fechaLocal.toLocaleDateString('es-ES', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const resetearFormulario = () => {
        setDatosAnses({
            fechaTurno: '',
            horaTurno: '',
            lugar: '',
            observaciones: '',
            comprobante: null
        });
    };

    const renderFormulario = () => (
        <div className="mt-4 p-4 border rounded-3 bg-light">
            <h5 className="fw-semibold text-primary mb-3">
                {turnoAnsesInfo ? 'Reprogramar Turno ANSES' : 'Cargar Turno ANSES'}
            </h5>

            <div className="row g-3">

                <div className="col-md-6">
                    <label className="form-label fw-semibold">Fecha Turno <span className="text-danger">*</span></label>
                    <div className="input-group">
                        <span className="input-group-text bg-light">
                            <CalendarMonthIcon fontSize="small" />
                        </span>
                        <input
                            type="date"
                            className="form-control shadow-sm"
                            value={datosAnses.fechaTurno}
                            onChange={(e) => setDatosAnses({ ...datosAnses, fechaTurno: e.target.value })}
                            required
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <label className="form-label fw-semibold">Hora Turno <span className="text-danger">*</span></label>
                    <div className="input-group">
                        <span className="input-group-text bg-light">
                            <AccessTimeIcon fontSize="small" />
                        </span>
                        <input
                            type="time"
                            className="form-control shadow-sm"
                            value={datosAnses.horaTurno}
                            onChange={(e) => setDatosAnses({ ...datosAnses, horaTurno: e.target.value })}
                            required
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <ComboboxDatosMaestros
                        opciones={lugares.filter(l => l.tipo === 'Oficina' || !l.tipo)}
                        valor={datosAnses.lugar}
                        onChange={(valor) => setDatosAnses({ ...datosAnses, lugar: valor })}
                        tipo="lugar"
                        tipoLugar="Oficina"
                        placeholder="Seleccione o escriba un lugar..."
                        label="Lugar"
                        icon={PlaceIcon}
                    />
                </div>

                <div className="col-12">
                    <label className="form-label fw-semibold">Observaciones</label>
                    <textarea
                        className="form-control shadow-sm"
                        rows="3"
                        placeholder="Observaciones adicionales..."
                        value={datosAnses.observaciones}
                        onChange={(e) => setDatosAnses({ ...datosAnses, observaciones: e.target.value })}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-center gap-3 mt-4">
                <button
                    className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={turnoAnsesInfo ? handleReprogramarTurnoAnses : handleCargarTurnoAnses}
                    disabled={cargando}
                >
                    {cargando ? (
                        'Procesando...'
                    ) : (
                        <>
                            <CheckCircleIcon fontSize="small" />
                            {turnoAnsesInfo ? 'Confirmar Reprogramación' : 'Confirmar Turno ANSES'}
                        </>
                    )}
                </button>

                <button
                    className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={() => {
                        setMostrarFormulario(false);
                        resetearFormulario();
                    }}
                    disabled={cargando}
                >
                    Cancelar
                </button>
            </div>
        </div>
    );

    /** Formulario de la junta médica. Se extrae porque hace falta en los DOS caminos: el
     *  flujo viejo de RTI y el nuevo, donde el turno lo maneja TarjetaTurnoAnses. Cuando
     *  la guarda mandaba a la tarjeta, este formulario quedaba inalcanzable y el trámite
     *  de RTI no podía avanzar a la junta. */
    const renderFormularioJunta = () => (
                <div className="mt-4 p-4 border rounded-3 bg-light">
                    <h5 className="fw-semibold text-primary mb-3">
                        <PeopleIcon className="me-2" />
                        {datosJunta.sinJunta ? 'Seguimiento sin junta médica' : 'Registrar Turno de Junta Médica'}
                    </h5>
                    <div className="form-check form-switch mb-3">
                        <input className="form-check-input" type="checkbox" role="switch" id="rti-sin-junta"
                            checked={Boolean(datosJunta.sinJunta)}
                            onChange={(e) => setDatosJunta({ ...datosJunta, sinJunta: e.target.checked })} />
                        <label className="form-check-label fw-semibold" htmlFor="rti-sin-junta">
                            Sin turno de junta médica (falta de declaración jurada)
                        </label>
                        <div className="form-text">
                            Se registra el expediente y empieza el seguimiento; el trámite pasa a "Espera de 1° Dictamen" sin junta.
                        </div>
                    </div>
                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label fw-semibold">N° Expediente <span className="text-danger">*</span></label>
                            <div className="input-group">
                                <span className="input-group-text bg-light"><DescriptionIcon fontSize="small" /></span>
                                <input type="text" className="form-control" placeholder="Número de expediente" value={datosJunta.numeroExpediente} onChange={(e) => setDatosJunta({ ...datosJunta, numeroExpediente: e.target.value })} />
                            </div>
                        </div>
                        {!datosJunta.sinJunta && (<>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Fecha Junta <span className="text-danger">*</span></label>
                            <input type="date" className="form-control" value={datosJunta.fecha} onChange={(e) => setDatosJunta({ ...datosJunta, fecha: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Hora Junta <span className="text-danger">*</span></label>
                            <input type="time" className="form-control" value={datosJunta.hora} onChange={(e) => setDatosJunta({ ...datosJunta, hora: e.target.value })} />
                        </div>
                        <div className="col-12">
                            <ComboboxDatosMaestros
                                opciones={lugares.filter(l => ['Oficina', 'Dependencia', 'Sala'].includes(l.tipo) || !l.tipo)}
                                valor={datosJunta.sede}
                                onChange={(valor) => setDatosJunta({ ...datosJunta, sede: valor })}
                                tipo="lugar"
                                tipoLugar="Oficina"
                                placeholder="Seleccione o escriba un lugar..."
                                label="Sede / Lugar"
                                required={true}
                                icon={BusinessIcon}
                            />
                        </div>
                        </>)}
                        <div className="col-12">
                            <label className="form-label fw-semibold">Observaciones</label>
                            <textarea
                                className="form-control shadow-sm"
                                rows="3"
                                placeholder="Observaciones adicionales..."
                                value={datosJunta.observaciones}
                                onChange={(e) => setDatosJunta({ ...datosJunta, observaciones: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <button className="btn btn-primary rounded-pill px-4" onClick={handleConfirmarJuntaMedica} disabled={cargando}>
                            {cargando ? 'Guardando...' : (datosJunta.sinJunta ? 'Confirmar sin junta médica' : 'Confirmar Junta Médica')}
                        </button>
                        <button className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setMostrarFormularioJunta(false)} disabled={cargando}>
                            Cancelar
                        </button>
                    </div>
                </div>
    );

    const renderDetallesTurno = () => {
        if (cargandoTurno) {
            return <div className="alert alert-info">Cargando detalles del turno ANSES...</div>;
        }

        if (!turnoAnsesInfo) {
            return <div className="alert alert-warning">Se deben cargar los detalles del turno ANSES asignado.</div>;
        }

        const descripcion = turnoAnsesInfo.descripcion || '';
        const lugarMatch = descripcion.match(/Lugar: (.*?)(?:\n|$)/);

        const fechaTurno = formatearFecha(turnoAnsesInfo.fecha);
        const horaTurno = turnoAnsesInfo.horaInicio || 'No especificada';
        const lugarTurno = lugarMatch ? lugarMatch[1] : 'No especificado';

        return (
            <>
                {/* Tarjeta de Gestión ANSES */}
                <div className="card bg-light border-0 rounded-3 p-4 mb-3">
                    <h5 className="fw-semibold text-secondary mb-3">Gestión ANSES</h5>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <CalendarMonthIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Fecha de Turno</small>
                                    <strong className="text-dark">{fechaTurno}</strong>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <AccessTimeIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Hora</small>
                                    <strong className="text-dark">{horaTurno.slice(0, 5)}</strong>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <PlaceIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Lugar</small>
                                    <strong className="text-dark">{lugarTurno}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 d-flex gap-2">
                        <BotonWhatsapp
                            idEvento={turnoAnsesInfo?.idEvento}
                            numeroTelefono={tramite.cliente?.telefonoPropio || tramite.cliente?.telefono}
                            nombreCliente={`${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`.trim()}
                            contactosAdicionales={tramite.cliente?.contactos}
                            fechaTurno={turnoAnsesInfo?.fecha}
                            horaTurno={turnoAnsesInfo?.horaInicio || turnoAnsesInfo?.hora}
                            // El evento va de la citación (horaInicio) a la hora en el organismo (horaFin).
                            horaTurnoAnses={turnoAnsesInfo?.horaFin}
                            lugar={lugarTurno}
                            tipoEvento="Turno Anses"
                            tramiteId={tramite?.idTramite}
                            className="btn-sm"
                        />
                    </div>
                </div>

                {/* Detalle del Turno */}
                <div className="card border-0 rounded-3 p-4 mb-3" style={{backgroundColor: '#f8f9fa'}}>
                    <h5 className="fw-semibold text-secondary mb-3">Detalle del Turno</h5>
                    <div className="row g-3 mb-3">
                        <div className="col-md-6">
                            <small className="text-muted d-block">Fecha/Hora</small>
                            <strong className="text-dark">{fechaTurno} - {horaTurno.slice(0, 5)}</strong>
                        </div>
                        <div className="col-md-6">
                            <small className="text-muted d-block">Estado de Asistencia</small>
                            <span className="badge bg-info">Pendiente</span>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const handleGuardarModificacionEvento = async (idEvento, eventoActualizado) => {
        try {
            await EventoService.modificarEvento(idEvento, eventoActualizado);
            setMostrarModificar(false);
            await cargarTurnoAnses();
            toast.success('Turno actualizado correctamente');
        } catch (error) {
            console.error('Error al modificar turno ANSES:', error);
            toast.error('No se pudo actualizar el turno');
        }
    };

    // No se decide nada hasta tener las DOS respuestas: si el trámite está en el módulo nuevo
    // y si tiene un turno viejo como evento. Con una sola, el render inicial elegiría la rama
    // equivocada y after cambiaría sola — y en el peor caso invitaría a cargar un duplicado.
    if (verificandoModulo || cargandoTurno) {
        return null;
    }

    // Los turnos nuevos se cargan con el módulo, no como evento de agenda. Se muestra la
    // tarjeta cuando el trámite ya tiene un turno real, y también cuando no tiene ninguno —
    // ahí la tarjeta ofrece "Cargar turno en ANSES" y el alta entra por el camino bueno:
    // citación en el turnero, presentación, y aparece en el listado ANSES.
    //
    // El formulario viejo queda solo para los trámites que todavía tienen su turno como
    // evento, hasta que se migren. Si se lo sacara ahora, esos turnos dejarían de verse.
    if (turnoDelModuloNuevo || !turnoAnsesInfo) {
        return (
            <>
                <TarjetaTurnoAnses
                    idTramite={tramite.idTramite}
                    nombreArea="este trámite de RTI"
                    nombreEstadoActual={tramite.nombreEstadoActual}
                    onCambio={onEstadoCambiado}
                    onEstadoCambiado={onEstadoCambiado}
                    // En RTI el trámite no cierra acá: del ingreso pasa a la junta médica.
                    ofreceResolucion={false}
                />

                {/* Lo propio de RTI, que la tarjeta no cubre y que el flujo necesita para poder
                    seguir. Al mostrar solo la tarjeta, estos dos quedaban inalcanzables: el
                    trámite no tenía forma de avanzar a la junta médica ni de registrar que el
                    cliente no fue. La junta NO es un simple cambio de estado — pide fecha, hora,
                    sede y expediente, y crea su evento de agenda. */}
                <div className="card shadow-sm border-0 rounded-4 p-4 mb-4">
                    <h5 className="fw-semibold text-primary mb-3">
                        <PeopleIcon className="me-2" />Paso siguiente en RTI
                    </h5>

                    {mostrarFormularioJunta ? renderFormularioJunta() : (
                        <div className="d-flex flex-wrap gap-3">
                            <button
                                className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => setMostrarFormularioJunta(true)}
                                disabled={cargando}
                            >
                                <CheckCircleIcon fontSize="small" />
                                Cargar turno Junta Médica
                            </button>
                            <button
                                className="btn btn-outline-danger d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={handleNoAsistioAnses}
                                disabled={cargando}
                            >
                                <EventBusyIcon fontSize="small" />
                                No asistió a ANSES
                            </button>
                        </div>
                    )}
                </div>
            </>
        );
    }

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-warning mb-0">Turno ANSES Asignado</h4>
                <span className="badge bg-warning rounded-pill px-3 py-2">
                    <ScheduleIcon fontSize="small" className="me-1" />
                    Pendiente de Presentación
                </span>
            </div>

            <div className="alert alert-warning border-0 rounded-3">
                <strong>Siguiente Paso:</strong>
                <p className="mb-0 mt-1">El cliente debe presentarse en ANSES en la fecha y hora asignadas.</p>
            </div>

            {renderDetallesTurno()}

            {mostrarFormulario ? (
                renderFormulario()
            ) : mostrarFormularioJunta ? (
                // --- FORMULARIO JUNTA MÉDICA ---
                renderFormularioJunta()
            ) : (
                <div className="d-flex flex-wrap justify-content-center gap-3">
                    <button
                        className="btn btn-warning d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                        onClick={() => setMostrarFormulario(true)}
                        disabled={cargando}
                    >
                        <EditCalendarIcon fontSize="small" />
                        {turnoAnsesInfo ? 'Reprogramar Turno' : 'Cargar Turno'}
                    </button>

                    {turnoAnsesInfo && (
                        <>
                            <button
                                className="btn btn-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => setMostrarModificar(true)}
                                disabled={cargando}
                                title="Corregir error de tipeo sin generar cambio de estado"
                            >
                                <EditCalendarIcon fontSize="small" />
                                Modificar Turno
                            </button>

                            <button
                                className="btn btn-danger d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={handleNoAsistioAnses}
                                disabled={cargando}
                            >
                                <EventBusyIcon fontSize="small" />
                                No Asistió
                            </button>

                            <button
                                className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => setMostrarFormularioJunta(true)}
                                disabled={cargando}
                            >
                                <CheckCircleIcon fontSize="small" />
                                Cargar turno Junta Médica
                            </button>
                        </>
                    )}
                </div>
            )}
            {turnoAnsesInfo && (
                <ModificarEventoModal
                    isOpen={mostrarModificar}
                    onClose={() => setMostrarModificar(false)}
                    evento={turnoAnsesInfo}
                    onSave={handleGuardarModificacionEvento}
                />
            )}
        </div>
    );
}

export default GestorEstadoTurnoAnses;

